// extracted by extract-css-chunks-webpack-plugin
module.exports = {"createdby-label":"MiniBoardCard-module_createdby-label__d61YH","list-item":"MiniBoardCard-module_list-item__1_9tI","list-img":"MiniBoardCard-module_list-img__11BOb"};